export default "__VITE_ASSET__B0hJe1qa__"